import { API } from 'config_app';

// eslint-disable-next-line import/prefer-default-export
export const RefreshEndpoint = `${API}/api/v1/sl_users/refresh/`;
